<app-header></app-header>
<div fxLayout="column" fxLayoutAlign="center center" class="card" *ngIf="!processing">
  <div *ngIf="!confirmed">
    <div>
      <mat-icon class="icon" color="primary">sentiment_very_dissatisfied</mat-icon>
      <div class="header">{{ 'CHANGE_EMAIL.CONFIRMATION_ERROR.TITLE' | translate }}</div>
    </div>

    <div *ngIf="error === 'inactive'" class="description">{{ 'CHANGE_EMAIL.CONFIRMATION_ERROR.INACTIVE' | translate }}</div>
    <div *ngIf="error === 'different'" class="description">{{ 'CHANGE_EMAIL.CONFIRMATION_ERROR.DIFFERENT' | translate }}</div>
    <div *ngIf="error === 'incorrect'" class="description">{{ 'CHANGE_EMAIL.CONFIRMATION_ERROR.INCORRECT' | translate }}</div>
    <div *ngIf="error === 'expired'" class="description">{{ 'CHANGE_EMAIL.CONFIRMATION_ERROR.EXPIRED' | translate }}</div>
    <div *ngIf="error === 'other'" class="description">{{ 'CHANGE_EMAIL.CONFIRMATION_ERROR.TEXT' | translate }}</div>
  </div>
  <div *ngIf="confirmed">
    <div>
      <mat-icon class="icon" color="primary">done_outline</mat-icon>
      <div class="header">{{ 'CHANGE_EMAIL.CONFIRMATION.TITLE' | translate }}</div>
    </div>
    <div class="description">{{ 'CHANGE_EMAIL.CONFIRMATION.TEXT' | translate }}</div>
  </div>
</div>
